export default __webpack_public_path__ + "locales/ro/BackupCodesDialog.json?hash=ded91a367d99a84e0040b1a1e58cb162";